export function FormatMoney(value, config = {}) {
	return Number(value).toLocaleString(
		config.local || 'pt-BR',
		{
			minimumFractionDigits: ![undefined].includes(config.endDigit) ? config.endDigit : 2
		}
	)
}